import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UploadFileDepotService {

  constructor(private http: HttpClient) { }


  /**
   * Génère et retourne le nom du fichier dans un format nomBase-Username.extension
   *
   * @param username
   * @param nomFichier
   * @param nouveauNomFichier
   */
  public getNomFichier(id: number, nomFichier: string, nouveauNomFichier: string): string {
    let extension= '';
    if (nomFichier){
      extension = nomFichier.split('.').pop();
    }

    return `${nouveauNomFichier}-${id}.${extension}`;
  }

    /**
   * Génère et retourne le nom du fichier dans un format nomBase-Username.extension
   *
   * @param username
   * @param nomFichier
   * @param nouveauNomFichier
   */
    public getNomFichierFrais(nomFichier: string, nouveauNomFichier: string): string {
      let extension= '';
      if (nomFichier){
        extension = nomFichier.split('.').pop();
      }
  
      return `${nouveauNomFichier}.${extension}`;
    }

  /**
   * Upload les images des justificatifs d'identité
   *
   * @param username
   * @param fichiers
   * @public
   */
  public uploadFichiers(ids: number[], fichiers: File[], prefixe: string): Promise<boolean> {
    return new Promise((resolve, reject) => {


      const promises: Promise<any>[] = [];

      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < fichiers.length; i++) {
        const formData = new FormData();
        formData.append('depotDemande', fichiers[i], this.getNomFichier(ids[i], fichiers[i].name, prefixe));
        // eslint-disable-next-line max-len
        promises.push(this.http.post(environment.apiBasePath + environment.apiFileBasePath + '/piece-identite/upload-file-depot-demande', formData,).toPromise());
      }
      Promise.all(promises)
        .then(() => resolve(true))
        .catch(() => reject(false));
    });
  }

    /**
   * Upload les images des justificatifs d'identité
   *
   * @param username
   * @param fichiers
   * @public
   */
    public uploadFichiersFrais(fichiers: File[], prefixe: string): Promise<boolean> {
      return new Promise((resolve, reject) => {
  
  
        const promises: Promise<any>[] = [];
  
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < fichiers.length; i++) {
          const formData = new FormData();
          formData.append('depotDemande', fichiers[i], this.getNomFichierFrais(fichiers[i].name, prefixe));
          // eslint-disable-next-line max-len
          promises.push(this.http.post(environment.apiBasePath + environment.apiFileBasePath + '/piece-identite/upload-file-depot-demande', formData,).toPromise());
        }
        Promise.all(promises)
          .then(() => resolve(true))
          .catch(() => reject(false));
      });
    }
}
